import React from 'react';
import './Tutorial.css';
import { Step1Icon, Step2Icon, Step3Icon, Step4Icon, Step5Icon } from '../../elements/icons/Icons';

const Tutorial = props => {
    return (
        <div className="tutorial">
            <div className="tutorial-line" />
            <div className="tutorial-items">
                <div className="tutorial-item">
                    <div className="circle">
                        <Step2Icon />
                    </div>
                    <div className="tutorial-caption">Post a question.</div>
                </div>
                <div className="tutorial-item">
                    <div className="circle">
                        <Step3Icon />
                    </div>
                    <div className="tutorial-caption">Get feedback from the community.</div>
                </div>
                <div className="tutorial-item">
                    <div className="circle">
                        <Step4Icon />
                    </div>
                    <div className="tutorial-caption">Donate to the best responses.</div>
                </div>
                <div className="tutorial-item">
                    <div className="circle circle-pink">
                        <Step5Icon className="pink" />
                    </div>
                    <div className="tutorial-caption pink">Proceed with the winning ideas.</div>
                </div>
            </div>
        </div>
    );
};

export default Tutorial;
